import { useTranslation } from 'react-i18next';

import { Card, Text } from '@ngsos/portal-ui';

import '../bootstrapJs';

const USER_PREFERRED_CULTURE_KEY = 'UserPrefferedCulture';

const SUPPORTED_CULTURES: { key: string; textKey: string; fallback: string }[] = [
  { key: 'en-US', textKey: 'Global_LanguageSelector_EN', fallback: 'English' },
  { key: 'cs', textKey: 'Global_LanguageSelector_CS', fallback: 'Czech' },
  { key: 'sk', textKey: 'Global_LanguageSelector_SK', fallback: 'Slovak' },
  { key: 'hu', textKey: 'Global_LanguageSelector_HU', fallback: 'Hungarian' },
  { key: 'de-AT', textKey: 'Global_LanguageSelector_DE', fallback: 'German' },
  { key: 'ro', textKey: 'Global_LanguageSelector_RO', fallback: 'Romanian' },
  { key: 'ro-MD', textKey: 'Global_LanguageSelector_MD', fallback: 'Romanian(Moldova)' },
  { key: 'it', textKey: 'Global_LanguageSelector_IT', fallback: 'Italian' },
];

const LIFT_OPEN_DROPDOWN_ABOVE_NEXT_CARD = 1;

export function LanguageSelector() {
  const { t } = useTranslation();

  const languageSelectorChanged = (selectedLanguage: string) => {
    window.localStorage.setItem(USER_PREFERRED_CULTURE_KEY, JSON.stringify(selectedLanguage));
    window.location.reload();
  };

  return (
    <Card style={{ zIndex: LIFT_OPEN_DROPDOWN_ABOVE_NEXT_CARD }}>
      <div className="d-flex justify-content-between align-items-center gap-3">
        <Text variant="title" role="heading" aria-level={3}>
          {t('Settings_Title_AppLanguage')}
        </Text>

        <div className="dropdown">
          <a
            className="dropdown-toggle btn btn-outline-primary"
            href="#"
            id="languageDropdown"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {t('Global_LanguageSelector_PlaceHolder')}
            <i className="far fa-xs fa-chevron-down"></i>
          </a>
          <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="languageDropdown">
            {SUPPORTED_CULTURES.map((culture) => (
              <li
                key={culture.key}
                className="dropdown-item"
                onClick={() => languageSelectorChanged(culture.key)}
              >
                {t(culture.textKey, culture.fallback)}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Card>
  );
}
